import * as React from 'react';
import { Input, message, Spin } from 'antd';
import CommonUtils from '@/utils/commonUtils';
import Urls from '@/config/url';
import https from '@/utils/ajaxUtils';
import storageUtils from '@/utils/storageUtils';
import config from '@/config/config';
class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: JSON.parse(storageUtils.get(config.loginStorageKey)),
      keyword: null,
      question: null,
      relativeWords: [
        {
          id: CommonUtils.generateUUID(),
          value: null,
        },
        {
          id: CommonUtils.generateUUID(),
          value: null,
        },
        {
          id: CommonUtils.generateUUID(),
          value: null,
        },
        {
          id: CommonUtils.generateUUID(),
          value: null,
        },
        {
          id: CommonUtils.generateUUID(),
          value: null,
        },
      ],
      loading: false,
    };
    this.keywords = ['遗传', '结节性硬化', '基因缺陷', 'Kanner', '药物'];
  }
  UNSAFE_componentWillMount() {
    const orderDetail = JSON.parse(sessionStorage.getItem('orderDetail'));
    const relativeWordsObj = JSON.parse(sessionStorage.getItem('relativeWordsObjStr'));
    if (orderDetail) {
      this.setState({
        keyword: orderDetail.keyword,
        question: orderDetail.question,
        relativeWords: relativeWordsObj
      })
    }
  }
  datachange = (v, type) => {
    if (type === 'keyword') {
      this.setState({ keyword: v });
    }
    if (type === 'question') {
      this.setState({ question: v });
    }
  }
  relativeWordsChange = (v, id) => {
    let relativeWords = this.state.relativeWords;
    for (let index = 0; index < relativeWords.length; index++) {
      const element = relativeWords[index];
      if (element.id === id) {
        element.value = v;
      }
    }
    this.setState({ relativeWords }, () => {
      console.log(this.state.relativeWords);
    });
  }
  commit = async () => {
    let relativeWords = this.state.relativeWords;
    if (!this.state.keyword || this.state.keyword.trim().length <= 0) {
      // message.error('请输入关键词');
      message.error('请至少填写带*号的内容');
      return;
    }
    if (!this.state.question || this.state.question.trim().length <= 0) {
      // message.error('请输入您关心的问题');
      message.error('请至少填写带*号的内容');
      return;
    }
    if (!relativeWords[0].value || relativeWords[0].value.trim().length <= 0) {
      // message.error('请输入相关词语');
      message.error('请至少填写带*号的内容');
      return;
    }
    let param = {
      keyword: this.state.keyword,
      question: this.state.question,
    };
    let relativeWordsStr = [];
    for (let index = 0; index < relativeWords.length; index++) {
      const element = relativeWords[index];
      if (element.value && element.value.trim().length > 0) {
        relativeWordsStr.push(element.value);
      }
    }
    param.relativeWords = relativeWordsStr.join(',');
    console.log('param: ', param);
    const orderDetail = window.JSON.stringify(param);
    const relativeWordsObjStr = window.JSON.stringify(relativeWords);
    sessionStorage.setItem('orderDetail', orderDetail)
    sessionStorage.setItem('relativeWordsObjStr', relativeWordsObjStr)
    this.setState({ loading: true });
    const res = await https.post(Urls.addOrder, param);
    this.setState({ loading: false });
    console.log('res: ', res);

    if (!res.success) {
      if (res.errCode === '111111') {
        this.props.history.push('/pay');
        message.info(res.errMsg);
      } else {
        message.error(res.errMsg);
      }
      return;
    }


    sessionStorage.removeItem("relativeWordsObjStr");
    sessionStorage.removeItem("orderDetail");
    this.props.history.push('/service/wait');

  }
  render() {
    return (
      <React.Fragment>
        <div className="top-img service">
          <img src="/img/service-top-img.png" alt="" />
          {/* <div className="page-name">服务</div> */}
        </div>
        <Spin tip="数据提交中..." spinning={this.state.loading}>
          <div className="index-content">
            <div className="service-form">
              <div className="form-item one">
                <div className="label"><span className="red">*</span>请输入关键词（能够代表您所关心话题的一个词或短语）</div>
                <div className="input">
                  <Input placeholder="例如：想了解自闭症相关的知识内容，可以输入关键词：Autism" value={this.state.keyword} onChange={(e) => { this.datachange(e.target.value, 'keyword') }} />
                </div>
              </div>
              <div className="form-item two">
                <div className="label"><span className="red">*</span>用一句话概括您关心的问题</div>
                <div className="input">
                  <Input placeholder="例如：自闭症的早期诊断标志物有哪些？" value={this.state.question} onChange={(e) => { this.datachange(e.target.value, 'question') }} />
                </div>
              </div>
              <div className="form-item three">
                <div className="label">请提供与关键词相关的5个词语，让棍棍更加理解您的需求</div>
                <div className="multiple">
                  <div className="name"><span className="red">*</span>相关词语：</div>
                  <div style={{ display: "flex" }}> {
                    this.state.relativeWords && this.state.relativeWords.length > 0 &&
                    this.state.relativeWords.map((v, index) => {
                      return <Input value={v.value} key={v.id} style={{ width: '22%' }} placeholder={`${index === 0 ? '例如：' : ''}${this.keywords[index] || this.keywords[0]}`} onChange={(e) => { this.relativeWordsChange(e.target.value, v.id) }} />;
                    })
                  }</div>
                </div>
              </div>
              <div className="action" >
                <div className="button" onClick={() => { this.commit() }}>
                  <img src="/img/service-search-button.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </React.Fragment>
    );
  }
}

export default Search;
